import { AppAvatar, FormCheckbox } from "@/shared/Components";
import { useGetAllPersonsQuery } from "@/services/api";
import { useRuntimeImage } from "@/entities/runtime-image";
import { handleFullName } from "@/shared/utils";
import type { Person } from "@/services/api";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  connection: Person["personConnections"][number];
  index: number;
};

export const Record: FC<Props> = ({ index, connection }) => {
  const { data: persons } = useGetAllPersonsQuery();
  const { getRuntimeImageURL } = useRuntimeImage();
  const currentPerson = persons?.persons.find(
    (person) => person.id === connection.connectionPersonId,
  );
  const personName = handleFullName(
    currentPerson?.firstName,
    currentPerson?.lastName,
    currentPerson?.middleName,
  );

  return (
    <div className={styles.root}>
      <div>
        <FormCheckbox name={`connections.${index}.selected`} />
      </div>
      <div className={styles.person}>
        <div className={styles.avatar}>
          <AppAvatar
            name={personName}
            image={getRuntimeImageURL({ fileId: currentPerson?.avatarFile?.fileId ?? "" })}
          />
        </div>
        <div className={styles["person-info"]}>
          <div className={styles["person-title"]}>{currentPerson?.title}</div>
          <div className={styles["person-name"]}>{personName}</div>
        </div>
        <div className={styles["note-title"]}>{connection.personConnectionType?.name}</div>
      </div>
    </div>
  );
};
